export const chars = /[?+#'’,.":°%]/g;
export const dot = /[.]/g;
export const whiteSpace = /^\s+|\s+$/g;
export const spacesReplace = /[-\s]+/g;
